import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FpAttachmentDto } from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class ApFileUploadService {
  convertToByteArray(file: File): Observable<FpAttachmentDto> {
    return new Observable((subscriber) => {
      const reader = new FileReader();
      reader.onload = () => {
        const attachmentDto: FpAttachmentDto = {
          Data: Array.from(new Uint8Array(reader.result as ArrayBuffer)),
          Extension: file.name.split('.').pop(),
          FileName: file.name,
          MimeType: file.type,
        };
        subscriber.next(attachmentDto);
        subscriber.complete();
      };
      reader.onerror = (error) => {
        subscriber.error(error);
      };
      reader.readAsArrayBuffer(file);
    });
  }

  convertToText(file: File): Observable<string> {
    return new Observable((subscriber) => {
      const reader = new FileReader();
      reader.onload = () => {
        subscriber.next(reader.result as string);
        subscriber.complete();
      };
      reader.onerror = (error) => {
        subscriber.error(error);
      };
      reader.readAsText(file);
    });
  }
}
